// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gkazv","error":"styles_error__WQjtb","recipients":"styles_recipients__FMeu7"};